import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/auth-context';
import { Fragment, useContext } from 'react';
import { List, ListItemButton, ListItemIcon, ListItemText, Divider, Box, Typography, Tooltip, IconButton } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import CategoryIcon from '@mui/icons-material/Category';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AssessmentIcon from '@mui/icons-material/Assessment';
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const NavLinks = ({ collapsed = false, onToggleCollapsed, onClose }) => {
  const auth = useContext(AuthContext);
  const location = useLocation();

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  const navItems = [
    { to: '/', label: 'Inicio', icon: <DashboardIcon fontSize="small" />, exact: true },
    { to: '/clientes', label: 'Clientes', icon: <PeopleIcon fontSize="small" /> },
    { to: '/items', label: 'Items', icon: <CategoryIcon fontSize="small" /> },
    { to: '/horas', label: 'Horas', icon: <AccessTimeIcon fontSize="small" /> },
    { to: '/reporte-horas', label: 'Reporte Horas', icon: <AssessmentIcon fontSize="small" /> }
  ];

  return (
    <Fragment>
      {/* Logo / Brand */}
      <Box
        sx={{
          px: collapsed ? 1.5 : 2,
          py: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1.5
        }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: collapsed ? 'center' : 'flex-start', gap: 1.5, minWidth: 0, flexGrow: 1 }}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: '10px',
              background: 'linear-gradient(135deg, #0d9488, #14b8a6)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
            <AccessTimeIcon sx={{ color: '#fff', fontSize: 20 }} />
          </Box>
          {!collapsed && (
            <Typography
              sx={{
                color: '#f1f5f9',
                fontFamily: '"Onest", sans-serif',
                fontWeight: 700,
                fontSize: '1.1rem',
                letterSpacing: '-0.02em'
              }}>
              Horas
            </Typography>
          )}
        </Box>
        {onToggleCollapsed && (
          <Tooltip title={collapsed ? 'Expandir menu lateral' : 'Contraer menu lateral'} placement="right">
            <IconButton
              onClick={onToggleCollapsed}
              size="small"
              sx={{
                color: '#cbd5e1',
                border: '1px solid',
                borderColor: '#334155',
                backgroundColor: 'rgba(15, 23, 42, 0.75)',
                flexShrink: 0,
                '&:hover': {
                  backgroundColor: '#1e293b',
                  borderColor: '#475569'
                }
              }}>
              {collapsed ? <ChevronRightIcon fontSize="small" /> : <ChevronLeftIcon fontSize="small" />}
            </IconButton>
          </Tooltip>
        )}
      </Box>

      <Divider sx={{ borderColor: '#1e293b', mx: collapsed ? 1.5 : 2 }} />

      {auth.isLoggedIn && (
        <List sx={{ px: 0, pt: 1, flexGrow: 1 }}>
          {navItems.map(({ to, label, icon, exact }) => {
            const active = exact ? location.pathname === to : isActive(to);
            const button = (
              <ListItemButton
                key={to}
                component={Link}
                to={to}
                selected={active}
                onClick={onClose}
                sx={{
                  minHeight: 42,
                  justifyContent: collapsed ? 'center' : 'flex-start',
                  '& .MuiListItemIcon-root': { color: active ? '#ffffff' : '#94a3b8' },
                  '& .MuiListItemText-primary': { color: active ? '#ffffff' : '#e2e8f0' }
                }}>
                <ListItemIcon sx={{ mr: collapsed ? 0 : 1 }}>{icon}</ListItemIcon>
                {!collapsed && <ListItemText primary={label} />}
              </ListItemButton>
            );
            return collapsed ? (
              <Tooltip key={to} title={label} placement="right">
                {button}
              </Tooltip>
            ) : (
              button
            );
          })}
        </List>
      )}

      {!auth.isLoggedIn && (
        <List sx={{ px: 0, pt: 1.5 }}>
          <ListItemButton component={Link} to="/auth" onClick={onClose} sx={{ justifyContent: collapsed ? 'center' : 'flex-start' }}>
            <ListItemIcon>
              <LoginIcon fontSize="small" />
            </ListItemIcon>
            {!collapsed && <ListItemText primary="Iniciar sesión" />}
          </ListItemButton>
        </List>
      )}

      {auth.isLoggedIn && (
        <Box sx={{ mt: 'auto', pb: 2 }}>
          <Divider sx={{ borderColor: '#1e293b', mx: 2, mb: 1 }} />
          <ListItemButton
            component={Link}
            to="/"
            onClick={() => {
              auth.logout();
              if (onClose) onClose();
            }}
            sx={{ mx: 1, borderRadius: 2, justifyContent: collapsed ? 'center' : 'flex-start' }}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            {!collapsed && <ListItemText primary="Salir" />}
          </ListItemButton>
        </Box>
      )}
    </Fragment>
  );
};

export default NavLinks;
